/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component, useEffect, useState} from 'react';
import { PageView, Event } from "../GoogleAnalytics";
import PartnerService from "../../services/partner.service";
import SharedOnboardingDashboard from './Dashboards/SharedOnboardingDashboard';
import {useNavigate} from "react-router-dom";
import AlertsService from "../../services/alerts.service";

const COLORS = ['#0033a0', '#3ed3c2', '#ff7555', '#ff9900', '#7d8ee2'];
const SUMMARY = "Summary";
const ASSET_TYPE = SUMMARY;

function SummaryOnboarding(props) {
    const {setActivePath, loggedInOrg, currentPartnerId, showAllTraining, setShowAllTraining ,customerCount , feedbackData} = props;
    const history = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isMounted, setIsMounted] = useState(false);
    const [showBtn, setShowBtn] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const [orgId, setOrgId] = useState(1);
    const [onboardInfo, setOnboardInfo] = useState({});
    const [assetStateCounts, setAssetStateCounts] = useState({});
    const [numAnalyticAlerts, setNumAnalyticAlerts] = useState(0);
    const [analyticAlertsLoading, setAnalyticAlertsLoading] = useState(false);

    const fetchOnboardingSummary = async () => {
        try {
            setOrgId(currentPartnerId);
            if (loggedInOrg !== "LifeWhere") {
                setShowBtn(false);
            }
            else if (showAllTraining) {
                setShowAll(true);
                setOrgId(1);
            }

            await populateInfo();
        } catch (error) {
            console.error('Error fetching onboarding summary:', error);
            setLoading(false);
        }
    };
    
    const populateInfo = async () => {
        await PartnerService.getonboardingsummary(orgId)
            .then(response => {
                if (response != null && response !== {}) {
                    setOnboardInfo(response);
                    setAssetStateCounts(response.assetStateCounts);
                    populateAnalyticAlertsCount();
                }
                else {
                    setLoading(false);
                }

            })
            .catch(e => {
                console.log(e);
            });
    }
    
    const populateAnalyticAlertsCount = () => {
        AlertsService.getanalyticalerts()
            .then(response => {
                if (response != null) {
                    let numAlerts = response.data?.alerts !== undefined ? response.data?.alerts.length : 0;
                    setNumAnalyticAlerts(numAlerts);
                }
                setLoading(false);
            })
            .catch(e => {
                console.log(e);
                setLoading(false);
            })
    }
    
    useEffect(() => {
        setIsMounted(true);
        PageView();
        fetchOnboardingSummary().then();

        return () => {
            setIsMounted(false);
        }
    }, []);
    
    const onShowAllClick = async () => {
        Event("Show All Clicked", `User clicked show all in ${ASSET_TYPE} Onboarding Dashboard`, "Show All Clicked");
        setLoading(true);
        setShowAll(!showAll);
        setShowAllTraining(showAll);
        
        let newOrgId = showAll ? 1 : currentPartnerId;
        setOrgId(newOrgId);
        
        await populateInfo();
    }
    
    const onTrainingReportClick = () => {
        setActivePath("/trainingSessionReview");
        const location = {
            pathname: "/trainingSessionReview"
        }

        history(location);
    }

    const onAssetStateClick = (state) => {
        Event("Asset State Clicked",`User clicked asset state in Summary Onboarding Dashboard`, "Asset State Clicked");
        setActivePath("/trainingSessionReview"); 
        const location = {
            pathname: "/trainingSessionReview"
        }

        history(location);
    }

    const onAnalyticAlertsClick = () => {
        setActivePath("/analyticAlerts");
        const location = {
            pathname: "/analyticAlerts"
        }

        history(location);
    }

    return (
        <SharedOnboardingDashboard assetType={ASSET_TYPE} onboardInfo={onboardInfo} assetStateCounts={assetStateCounts} isSummary={true} numAnalyticAlerts={numAnalyticAlerts}
                                   onAssetStateClick={onAssetStateClick} onTrainingReportClick={onTrainingReportClick}  onAnalyticAlertsClick={onAnalyticAlertsClick}
                                   loading={loading} showAllTraining={showAllTraining} showShowAllBtn={showBtn} onShowAllClick={onShowAllClick}  customerCount={customerCount} feedbackData={feedbackData}/>

    );
}

export default SummaryOnboarding;